import HttpClient from './http-client';
import URL from './url';

export default class SchoolUserApi {

    static assignHomework(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ASSIGN_HOMEWORK + "?" + params.join('&') : URL.ASSIGN_HOMEWORK;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getSchoolUsers(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SCHOOL_USERS + "?" + params.join('&') : URL.SCHOOL_USERS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getUsers(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENTS_LIST + "?" + params.join('&') : URL.STUDENTS_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getUsersUpgradedCount(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SCHOOL_USERS_UPGRADED + "?" + params.join('&') : URL.SCHOOL_USERS_UPGRADED;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static addSchoolUser(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_USERS, null, payload);
    }
    static addBulkSchoolUser(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_USERS_BULK, null, payload);
    }

    static addSchoolsNameListAsStudentName(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_NAME_LIST_AS_STUDENT_NAME_BULK, null, payload);
    }

    static updateSchoolUser(payload) {
        return HttpClient.put(URL.BASE_URL + URL.SCHOOL_USERS, null, payload);
    }

    static deleteSchoolUser(payload) {
        return HttpClient.delete(URL.BASE_URL + URL.SCHOOL_USERS, null, payload);
    }

    static getEventReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_REPORT + "?" + params.join('&') : URL.GET_EVENT_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getEventConslidatedReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_CONSOLIDATED_REPORT + "?" + params.join('&') : URL.GET_EVENT_CONSOLIDATED_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    
    static getSurveyReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_SURVEY_REPORT + "?" + params.join('&') : URL.GET_SURVEY_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventStudentList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_STUDENT_LIST + "?" + params.join('&') : URL.GET_EVENT_STUDENT_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventEvaluationReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_STUDENT_EVALUATION_REPORT + "?" + params.join('&') : URL.GET_EVENT_STUDENT_EVALUATION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventNationalAverage(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_NATIONAL_AVERAGE + "?" + params.join('&') : URL.GET_EVENT_NATIONAL_AVERAGE;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventPerformaceReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_PERFORMANCE_REPORT + "?" + params.join('&') : URL.GET_EVENT_PERFORMANCE_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventStudentPerformanceList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_PERFORMANCE_LIST + "?" + params.join('&') : URL.GET_EVENT_PERFORMANCE_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventAggregateByClass(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_AGGREGATE_BY_CLASS + "?" + params.join('&') : URL.GET_EVENT_AGGREGATE_BY_CLASS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getEventWinnersList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_EVENT_WINNERS_LIST + "?" + params.join('&') : URL.GET_EVENT_WINNERS_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_REPORT + "?" + params.join('&') : URL.GET_IMD_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDStudentList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_STUDENT_LIST + "?" + params.join('&') : URL.GET_IMD_STUDENT_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDEvaluationReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_STUDENT_EVALUATION_REPORT + "?" + params.join('&') : URL.GET_IMD_STUDENT_EVALUATION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDNationalAverage(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_NATIONAL_AVERAGE + "?" + params.join('&') : URL.GET_IMD_NATIONAL_AVERAGE;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDPerformaceReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_PERFORMANCE_REPORT + "?" + params.join('&') : URL.GET_IMD_PERFORMANCE_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }
    static getIMDStudentPerformanceList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_PERFORMANCE_LIST + "?" + params.join('&') : URL.GET_IMD_PERFORMANCE_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getIMDWinnersList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_IMD_WINNERS_LIST + "?" + params.join('&') : URL.GET_IMD_WINNERS_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStaffAndSchoolDetails(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STAFF_SCHOOL_DETAILS + "?" + params.join('&') : URL.STAFF_SCHOOL_DETAILS;
        return HttpClient.get(URL.BASE_URL + paramsList, null, payload);
    }

    static sendUsersSignupOTP(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_USERS_SIGNUP_OTP, null, payload);
    }

    static schoolUserSignup(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SCHOOL_USERS_SIGNUP, null, payload);
    }

    static approveUser(payload) {
        return HttpClient.post(URL.BASE_URL + URL.APPROVE_SCHOOL_USER, null, payload);
    }

    static userSchoolApprovalStatusUpdate(payload) {
        return HttpClient.put(URL.BASE_URL + URL.USER_SCHOOL_APPROVAL_STATUS_UPDATE, null, payload);
    }

    static userSchoolApprovalBulkUpdate(payload) {
        return HttpClient.put(URL.BASE_URL + URL.USER_SCHOOL_APPROVAL_BULK_UPDATE, null, payload);
    }

    static bulkAssignClassSection(payload) {
        return HttpClient.put(URL.BASE_URL + URL.BULK_ASSIGN_CLASS_SECTION, null, payload);
    }

    static sendStudentBulkInvite(payload) {
        return HttpClient.post(URL.BASE_URL + URL.STUDENT_BULK_INVITE, null, payload);
    }
}